/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_Passkey_Required_TitleInputs */

const en_add_passkey_required_title = /** @type {(inputs: Add_Passkey_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a new passkey`)
};

const de_add_passkey_required_title = /** @type {(inputs: Add_Passkey_Required_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Passkey erstellen`)
};

/**
* | output |
* | --- |
* | "Create a new passkey" |
*
* @param {Add_Passkey_Required_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const add_passkey_required_title = /** @type {((inputs?: Add_Passkey_Required_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_Passkey_Required_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_add_passkey_required_title(inputs)
	return en_add_passkey_required_title(inputs)
});